import { useContext } from "react";
import { ServiceContext } from "@RequestFormV2/sections/Service/context/ServiceProvider";

export function useService() {
  const context = useContext(ServiceContext);
  if (!context) {
    throw new Error("useService must be used within a ServiceProvider");
  }
  return context;
}
